__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "cnp_aa_cap_vencedor_front";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@ds/react", "2.3.3", () => (Promise.all([__webpack_require__.e(4), __webpack_require__.e(656), __webpack_require__.e(686), __webpack_require__.e(64)]).then(() => (() => (__webpack_require__(7553))))));
			register("@ds/tema-cnp", "2.2.0", () => (__webpack_require__.e(657).then(() => (() => (__webpack_require__(5657))))));
			register("axios", "0.27.2", () => (__webpack_require__.e(854).then(() => (() => (__webpack_require__(854))))));
			register("crypto-js", "4.2.0", () => (Promise.all([__webpack_require__.e(111), __webpack_require__.e(477)]).then(() => (() => (__webpack_require__(6111))))));
			register("react-document-meta", "3.0.0-beta.2", () => (Promise.all([__webpack_require__.e(656), __webpack_require__.e(944)]).then(() => (() => (__webpack_require__(1944))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(656)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-helmet", "6.1.0", () => (Promise.all([__webpack_require__.e(858), __webpack_require__.e(656)]).then(() => (() => (__webpack_require__(6477))))));
			register("react-router-dom", "6.30.6", () => (Promise.all([__webpack_require__.e(387), __webpack_require__.e(475), __webpack_require__.e(656), __webpack_require__.e(686), __webpack_require__.e(479)]).then(() => (() => (__webpack_require__(5475))))));
			register("react-router", "6.30.6", () => (Promise.all([__webpack_require__.e(387), __webpack_require__.e(216), __webpack_require__.e(656)]).then(() => (() => (__webpack_require__(3216))))));
			register("react-slick", "0.29.0", () => (Promise.all([__webpack_require__.e(382), __webpack_require__.e(656)]).then(() => (() => (__webpack_require__(2382))))));
			register("react", "18.3.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(816), __webpack_require__.e(656)]).then(() => (() => (__webpack_require__(2816))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};